<template>
  <template v-for="heatmap in heatmaps" :key="heatmap.title[locale] + heatmap.name">
    <CardHeatmap />
  </template>
</template>

<script lang="ts" setup>
import { LocaleString } from '@/api-client/models/utilization/Contracts'
import CardHeatmap from './CardHeatmap.vue'

export type Heatmap = {
  name: string
  title: LocaleString
  info?: LocaleString
  props: any
}

type Props = {
  heatmaps: Heatmap[]
}

defineProps<Props>()
</script>
